import { render, staticRenderFns } from "./kiyaku.vue?vue&type=template&id=22d33c34&scoped=true&"
import script from "./kiyaku.vue?vue&type=script&lang=js&"
export * from "./kiyaku.vue?vue&type=script&lang=js&"
import style0 from "./kiyaku.vue?vue&type=style&index=0&id=22d33c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d33c34",
  null
  
)

export default component.exports